import React from 'react'
import PropTypes from 'prop-types'
import { Button, Classes, Dialog } from '@blueprintjs/core'

import styles from './confirmDialog.module.scss'

class ConfirmDialog extends React.Component {
    static propTypes = {
        title: PropTypes.node.isRequired,
        isOpen: PropTypes.bool.isRequired,
        confirmLabel: PropTypes.string,
        confirmIntent: PropTypes.string,
        cancelLabel: PropTypes.string,
        onConfirm: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        children: PropTypes.node,
    }

    static defaultProps = {
        confirmLabel: 'Confirm',
        cancelLabel: 'Cancel',
        confirmIntent: 'none',
    }

    render() {
        const {
            title,
            isOpen,
            confirmLabel,
            confirmIntent,
            cancelLabel,
            onConfirm,
            onCancel,
            children,
        } = this.props

        return (
            <Dialog
                onClose={onCancel}
                title={title}
                isOpen={isOpen}
                canOutsideClickClose={false}
                className={styles.dialog}
            >
                <div className={Classes.DIALOG_BODY}>{children}</div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div
                        className={`${Classes.DIALOG_FOOTER_ACTIONS} ${styles.footerActions}`}
                    >
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={onCancel}
                        >
                            {cancelLabel}
                        </Button>
                        <Button
                            large
                            intent={confirmIntent}
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default ConfirmDialog
